export const COMPANY_INFO = {
  name: "Skræp Vinduespuds",
  phone: "+45 28 68 74 92", // Opdateret telefonnummer
  email: "Skraepvinduespuds@outlook.dk",
  address: "Odensevej 123, 5000 Odense C",
  geoArea: "Hele Fyn",
  logoText: "Skræp Vinduespuds",
  metaTitle: "Skræp Vinduespuds | Vinduespudsning, Solceller, Algerens & Rengøring på Fyn",
  metaDescription: "Professionel vinduespudsning til private og erhverv på hele Fyn. Skræp Vinduespuds tilbyder også rens af solceller, algerens af tag samt rengøring af campingvogne. Kontakt mig for et uforpligtende tilbud."
};

export const SERVICES = [
  {
    id: "vinduespudsning-privat",
    slug: "vinduespudsning-privat",
    title: "Vinduespudsning Privat",
    shortDescription: "Professionel vinduespudsning til private hjem på hele Fyn. Jeg sikrer krystalklare ruder uden striber, så du kan nyde dagslyset fuldt ud.",
    longDescription: "Hos Skræp Vinduespuds forstår jeg, at rene vinduer gør en kæmpe forskel for dit hjem. Jeg tilbyder professionel vinduespudsning til alle typer private boliger på Fyn – uanset om du bor i et klassisk parcelhus, en moderne patriciervilla eller en lejlighed på 3. sal. Jeg anvender professionelt udstyr og miljøvenlige sæbeprodukter, der sikrer et perfekt, stribefrit resultat hver gang. Du kan vælge en enkeltstående pudsning eller tilmelde dig en fast, fleksibel abonnementsordning, så dine vinduer altid fremstår knivskarpe.",
    image: "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/shutterstock-2622574991-1_1.jpg",
    benefits: [
      "Stribefrit resultat hver eneste gang",
      "Pålidelige aftaler – jeg kommer som aftalt",
      "Miljøvenlige og skånsomme sæbeprodukter",
      "Mulighed for fast og fleksibelt abonnement"
    ],
    process: [
      { step: "1", title: "Forberedelse & inspektion", desc: "Jeg gennemgår ruderne og rammerne for at vurdere eventuelle genstridige pletter eller belægninger." },
      { step: "2", title: "Indsæbning", desc: "Jeg påfører min specialudviklede, miljøvenlige sæbe, der effektivt løsner snavs, pollen og fedt." },
      { step: "3", title: "Professionel polering", desc: "Med præcision og professionelle gummiskrabere trækker jeg vandet af ruderne uden at efterlade striber." },
      { step: "4", title: "Aftørring af kanter", desc: "Jeg tørrer alle kanter, karme og sålbænke af med en ren mikrofiberklud for en perfekt finish." }
    ]
  },
  {
    id: "vinduespudsning-erhverv",
    slug: "vinduespudsning-erhverv",
    title: "Vinduespudsning Erhverv",
    shortDescription: "Giv din virksomhed det bedste førstehåndsindtryk med skinnende rene vinduer. Jeg pudser for kontorer, butikker og erhvervsejendomme.",
    longDescription: "Et professionelt ydre er afgørende for enhver virksomhed. Skræp Vinduespuds tilbyder skræddersyede erhvervsaftaler til kontordomiciler, butiksfacader, institutioner og boligforeninger over hele Fyn. Jeg tilpasser mig fuldstændig jeres arbejdsdag, så jeg forstyrrer mindst muligt – jeg kan pudse tidligt om morgenen, uden for åbningstid eller i weekenderne. Med mit professionelle udstyr og fokus på sikkerhed klarer jeg både mindre butiksruder og store, komplekse glasfacader med samme høje præcision.",
    image: "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/image00002.jpeg",
    benefits: [
      "Fleksibel planlægning (også uden for åbningstid)",
      "Skræddersyede abonnementsaftaler",
      "Erfaren og fuldt forsikret vinduespudser",
      "Professionel rengøring af store glaspartier"
    ],
    process: [
      { step: "1", title: "Behovsafdækning", desc: "Jeg besigtiger ejendommen og aftaler omfanget, frekvensen og de mest hensigtsmæssige tidspunkter." },
      { step: "2", title: "Sikkerhed & klargøring", desc: "Jeg sikrer arbejdsområdet og anvender godkendt sikkerhedsudstyr til opgaven." },
      { step: "3", title: "Effektiv udførelse", desc: "Jeg pudser vinduerne hurtigt, diskret og med maksimalt fokus på kvalitet." },
      { step: "4", title: "Kvalitetssikring", desc: "Jeg foretager en grundig slutkontrol og sender en elektronisk faktura med det samme." }
    ]
  },
  {
    id: "solcellerens",
    slug: "solcellerens",
    title: "Solcellerens",
    shortDescription: "Snavsede solceller kan miste op til 30% af deres effektivitet. Jeg renser dine solceller skånsomt med ultra-rent vand for maksimalt udbytte.",
    longDescription: "Solceller er en fantastisk investering, men vidste du, at snavs, støv, pollen, sod og fugleklatter gradvist danner en hinde over panelerne? Det kan reducere dit anlægs effektivitet med helt op til 30%. Hos Skræp Vinduespuds tilbyder jeg professionel solcellerens på hele Fyn. Jeg anvender udelukkende ultra-rent vand (kalk- og mineralfrit vand) og specialudviklede bløde børster. Jeg bruger ALDRIG kemikalier eller almindeligt postevand, da det kan efterlade kalkaflejringer eller beskadige panelerne. En regelmæssig rens sikrer, at dit anlæg altid yder sit absolut maksimale.",
    image: "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/df307af1-4bd3-49b1-bcdd-d5b6dbccf628.jpg",
    benefits: [
      "Øger anlæggets strømproduktion med op til 30%",
      "Skånsom vask helt uden skadelige kemikalier",
      "Brug af ultra-rent vand forhindrer kalkpletter",
      "Forlænger solcellepanelernes levetid"
    ],
    process: [
      { step: "1", title: "Visuel kontrol", desc: "Jeg tjekker panelerne for eventuelle skader eller særligt genstridige belægninger inden start." },
      { step: "2", title: "Ultra-rent vand", desc: "Jeg tilkobler mit vaskeanlæg, der leverer 100% rent, filtreret vand uden kalk og mineraler." },
      { step: "3", title: "Skånsom børstning", desc: "Med teleskopstænger og bløde specialbørster løsner og fjerner jeg alt snavs uden at ridse glasset." },
      { step: "4", title: "Afskylning & tørring", desc: "Panelerne skylles efter med det rene vand og tørrer naturligt op uden pletter eller striber." }
    ]
  },
  {
    "id": "algerens-tag",
    "slug": "algerens-tag",
    "title": "Algerens af Tag",
    "shortDescription": "Alger og mos holder på fugten og kan skade dit tag. Min professionelle algerens fjerner belægningerne effektivt og beskytter dit tag.",
    "longDescription": "Det fugtige danske klima giver optimale vækstbetingelser for alger og mos på tagfladerne. Hvis det ikke behandles, kan rødderne trænge ind i tagstenene, holde på fugten og i værste fald føre to frostsprængninger og dyre tagskader. Skræp Vinduespuds tilbyder professionel algerens af tag på hele Fyn. Jeg anvender miljøgodkendte og yderst effektive algebekæmpelsesmidler, som sprøjtes ud over taget som et skum. Midlet trænger dybt ind i belægningerne og dræber algerne ved roden. Herefter klarer vind og vejr resten af arbejdet ved gradvist at skylle de døde alger væk, så dit tag genvinder sit flotte udseende.",
    "image": "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/image00008_1.jpeg",
    "benefits": [
      "Forebygger dyre frostsprængninger og utætheder",
      "Giver dit hus et flot, fornyet og præsentabelt udtryk",
      "Miljøgodkendte og skånsomme skumbehandlinger",
      "Forlænger tagets levetid med mange år"
    ],
    "process": [
      { "step": "1", "title": "Taginspektion", "desc": "Jeg vurderer tagets materiale, hældning og mængden af algevækst for at sikre den rette behandling." },
      { "step": "2", "title": "Udlægning af algeskum", "desc": "Med professionelt sprøjteudstyr fordeler jeg et jævnt lag af miljøgodkendt algedræbende skum på taget." },
      { "step": "3", "title": "Virkningsperiode", "desc": "Skummet trænger ind i algerne og mosset og nedbryder dem effektivt over de efterfølgende dage." },
      { "step": "4", "title": "Naturlig afskylning", "desc": "Regn og vind vil over de næste uger og måneder gradvist skylle de visne alger og mosrester væk." }
    ]
  },
  {
    "id": "algerens-fliser",
    "slug": "algerens-fliser",
    "title": "Algerens af Fliser & Sten",
    "shortDescription": "Fjern alger, flisepest og mos fra dine fliser og sten. Jeg renser og imprægnerer dine udendørsarealer, så de bliver som nye igen.",
    "longDescription": "Fliser og sten i indkørsler, på terrasser og gangstier bliver over tid angrebet af alger, mos og flisepest. Dette ser ikke blot kedeligt ud, men kan også gøre overfladerne ekstremt glatte og farlige at færdes på, når det regner. Hos Skræp Vinduespuds tilbyder jeg professionel algerens og fliserens på hele Fyn. Jeg anvender miljøvenlige og effektive rensemidler kombineret med professionelt udstyr, der skånsomt men effektivt fjerner alle urenheder uden at beskadige flisernes overflade. Jeg tilbyder også en efterfølgende imprægnering, der beskytter fliserne mod fremtidige angreb og holder dem pæne i mange år.",
    "image": "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/image00007.jpeg",
    "benefits": [
      "Fjerner effektivt alger, mos og genstridig flisepest",
      "Gør glatte overflader sikre at færdes på igen",
      "Skånsom og miljøvenlig rensning af alle stentyper",
      "Mulighed for imprægnering for langvarig beskyttelse"
    ],
    "process": [
      { "step": "1", "title": "Besigtigelse & vurdering", "desc": "Jeg undersøger flisernes tilstand og omfanget af alger og flisepest for at vælge den rette behandlingsmetode." },
      { "step": "2", "title": "Professionel fliserens", "desc": "Med specialudstyr renser jeg fliserne i dybden og fjerner skidt, mos og belægninger skånsomt." },
      { "step": "3", "title": "Algebehandling", "desc": "Jeg påfører en effektiv algedræber, som sikrer, at de mikroskopiske algesporer i dybden dør." },
      { "step": "4", "title": "Imprægnering (valgfrit)", "desc": "Jeg forsegler overfladen med en beskyttende imprægnering, der gør fliserne modstandsdygtige over for nyt snavs." }
    ]
  },
  {
    id: "campingvogne",
    slug: "campingvogne",
    title: "Udvendig Rengøring af Campingvogne",
    shortDescription: "Lad mig gøre din campingvogn skinnende ren og klar til landevejen. Jeg fjerner genstridige sorte striber, alger og vejfilm skånsomt.",
    longDescription: "Efter en lang sæson på campingpladsen eller efter vinteropbevaring kan en campingvogn hurtigt blive mat, beskidt og dækket af sorte striber, alger og vejfilm. At rengøre den selv kan være en tidskrævende og hård opgave. Hos Skræp Vinduespuds tilbyder jeg en komplet udvendig rengøring af din campingvogn på Fyn. Jeg vasker vognen skånsomt i hånden med specialudviklede plejemidler, der effektivt opløser de berygtede sorte striber og beskytter lakken og plastvinduerne mod ridser. Jeg sørger for, at din campingvogn står funklende ren og klar til nye eventyr på landevejen.",
    image: "https://assets.auxodev.dk/assets/66f352d5-c4b9-4e8b-8d46-eb7bb9ac1d49/306c118a-780b-45b1-b654-8d6e02fdf97c.jpg",
    benefits: [
      "Effektiv fjernelse of sorte striber og vejfilm",
      "Skånsom håndvask, der beskytter lak og ruder",
      "Professionelle og biologisk nedbrydelige midler",
      "Spar tid og besvær – jeg klarer det hårde arbejde"
    ],
    process: [
      { step: "1", title: "Grundig forvask", desc: "Jeg spuler campingvognen grundigt for at fjerne løst snavs, sand og støv, så jeg undgår ridser under vasken." },
      { step: "2", title: "Specialbehandling", desc: "Jeg påfører en effektiv specialshampoo, der er målrettet sorte striber, alger og fastgroet vejfilm." },
      { step: "3", title: "Skånsom håndvask", desc: "Hele vognen – herunder tag, sider, lygter og ruder – vasker jeg omhyggeligt i hånden med bløde børster." },
      { step: "4", title: "Afskylning & finish", desc: "Jeg skyller efter med kalkfrit vand, så vognen tørrer op uden kalkpletter og efterlader en flot, skinnende overflade." }
    ]
  }
];

export const ADVANTAGES = [
  {
    title: "Hele Fyn",
    description: "Jeg dækker hele Fyn – fra Odense til Svendborg, Middelfart, Nyborg og alle mindre byer derimellem.",
    icon: "MapPin"
  },
  {
    title: "Privat & Erhverv",
    description: "Jeg tilbyder fleksible løsninger tilpasset både private hjem og professionelle erhvervsejendomme.",
    icon: "Building2"
  },
  {
    title: "Høj Kvalitet",
    description: "Jeg går aldrig på kompromis med kvaliteten. Jeg leverer altid et stribefrit og perfekt resultat.",
    icon: "Sparkles"
  },
  {
    title: "Pålidelig Service",
    description: "En aftale er en aftale. Jeg kommer til den aftalte tid, og jeg udfører arbejdet med et smil.",
    icon: "ShieldCheck"
  }
];

export const WHY_CHOOSE_US = [
  {
    title: "Lokalt fokus",
    description: "Som en lokal fynsk vinduespudser kender jeg området og vægter det personlige forhold til mine kunder utrolig højt."
  },
  {
    title: "Fleksible aftaler",
    description: "Uanset om du ønsker en enkeltstående pudsning eller en fast abonnementsordning, skræddersyr jeg det efter dine behov."
  },
  {
    title: "Professionelt resultat",
    description: "Jeg bruger kun professionelt udstyr, ultra-rent vand og miljøvenlige produkter for at sikre det absolut bedste resultat."
  },
  {
    title: "God kundeservice",
    description: "Jeg er let at få fat på, svarer hurtigt på henvendelser og stræber altid efter, at du er 100% tilfreds med mit arbejde."
  }
];

export const REVIEWS = [
  {
    name: "Mads Hansen",
    location: "Odense",
    text: "Super professionel service! Mine vinduer har aldrig været så rene. Kan varmt anbefales til alle på Fyn.",
    stars: 5
  },
  {
    name: "Sofie Nielsen",
    location: "Svendborg",
    text: "Pålidelig og venlig vinduespudser. Skræp overholder altid aftalerne, og resultatet er perfekt hver gang. Rigtig god pris!",
    stars: 5
  },
  {
    name: "Jesper Jensen",
    location: "Middelfart",
    text: "Fik renset vores solceller og pudset vinduer. Effektivt arbejde og mærkbar forskel på vores strømproduktion efterfølgende!",
    stars: 5
  },
  {
    name: "Charlotte Poulsen",
    location: "Nyborg",
    text: "Vores campingvogn blev som ny efter en udvendig rengøring hos Skræp. Fantastisk stykke arbejde og super service!",
    stars: 5
  },
  {
    name: "Morten Andersen",
    location: "Faaborg",
    text: "Algerens af taget blev udført hurtigt og professionelt. Taget ser fantastisk ud nu, og alle grønne belægninger er helt væk.",
    stars: 5
  },
  {
    name: "Lene Kristensen",
    location: "Ringe",
    text: "Rigtig god kundeservice og fleksible aftaler. Det er en fornøjelse at være kunde hos Skræp. Hun får mine varmeste anbefalinger.",
    stars: 5
  }
];
